import {Pipe, PipeTransform} from '@angular/core'
import {I18nService} from '../../@core/translate/i18n.service'

@Pipe({name: 'lang'})
export class LangPipe implements PipeTransform {
  constructor(public i18n: I18nService) {}

  transform(value: any): string {
    return typeof value === 'object' ? this.i18n.toViewWithDefault(value, '') : value
  }
}
